import React from 'react';
import {CardContainerStyle, CardContentStyle, CardFooterStyle} from './styles';
import {StyledCardProps} from './types';

function StyledCardRoot({children}: StyledCardProps) {
	return <CardContainerStyle>{children}</CardContainerStyle>;
}

function StyledCardContent({children}: StyledCardProps) {
	return <CardContentStyle>{children}</CardContentStyle>;
}

function StyledCardFooter({children}: StyledCardProps) {
	return <CardFooterStyle>{children}</CardFooterStyle>;
}

export const StyledCard = {
	Root: StyledCardRoot,
	Content: StyledCardContent,
	Footer: StyledCardFooter,
};
